/**
 * Concise Airflow Hat preorder note in Rebuy Smart Cart.
 * Native cart/page rendering is handled in snippets/cart-form.liquid.
 */
(function () {
  var STYLE_ID = 'dbp-cart-note-style';
  var ORDER_TYPE = 'Airflow Hat Preorder';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.dbp-cart-summary{display:block;margin-top:6px;max-width:34em;font-size:11px;line-height:1.4;color:#5d5540}',
      '.rebuy-cart__flyout-item.is-dbp-preorder .rebuy-cart__flyout-item-property,',
      '.rebuy-cart__flyout-item.is-dbp-preorder .rebuy-cart__flyout-item-properties{display:none!important}'
    ].join('');
    document.head.appendChild(style);
  }

  function isPreorder(item) {
    return !!(item && item.properties && item.properties['Order type'] === ORDER_TYPE);
  }

  function summaryText(item) {
    var colorway = (item.properties && item.properties.Colorway) || '';
    var lead = colorway ? 'Preorder · ' + colorway : 'Preorder';
    return lead + ' · ships 6–8 weeks after Sept 7.';
  }

  function decorate(node, item) {
    if (!node || !isPreorder(item)) return;
    node.classList.add('is-dbp-preorder');
    if (node.querySelector('.dbp-cart-summary')) {
      node.querySelector('.dbp-cart-summary').textContent = summaryText(item);
      return;
    }
    var note = document.createElement('div');
    note.className = 'dbp-cart-summary';
    note.textContent = summaryText(item);
    var mount = node.querySelector('.rebuy-cart__flyout-item-product-title, .rebuy-cart__flyout-product-title, .rebuy-cart__flyout-item-info, .rebuy-cart__flyout-item-details');
    (mount || node).appendChild(note);
  }

  function apply(cart) {
    if (!cart || !cart.items) return;
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.rebuy-cart__flyout-item'));
    if (!nodes.length) return;

    if (nodes.length === cart.items.length) {
      cart.items.forEach(function (item, index) {
        decorate(nodes[index], item);
      });
      return;
    }

    var used = {};
    cart.items.forEach(function (item) {
      if (!isPreorder(item)) return;
      for (var i = 0; i < nodes.length; i++) {
        if (used[i]) continue;
        var text = nodes[i].textContent || '';
        if (item.product_title && text.indexOf(item.product_title) === -1) continue;
        if (item.variant_title && item.variant_title !== 'Default Title' && text.indexOf(item.variant_title) === -1) continue;
        used[i] = true;
        decorate(nodes[i], item);
        break;
      }
    });
  }

  function refresh() {
    ensureStyle();
    var local = window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.cart;
    if (local && local.items) {
      apply(local);
      return;
    }
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(apply)
      .catch(function () {});
  }

  document.addEventListener('rebuy:cart.ready', refresh);
  document.addEventListener('rebuy:cart.change', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
})();
